export default __webpack_public_path__ + "static/media/deleteIcon.8dd42cb4.svg";